const config = {

  API_BASE_URL:
    process.env.REACT_APP_API_URL ||
    "https://tulithevlogger.com",

  IMAGE_BASE_URL:
    process.env.REACT_APP_IMAGE_URL ||
    "https://tulithevlogger.com/uploads"

};

export default config;